const isEmailAddressValid = (email: string) => {
  const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

  return email.match(emailRegex);
};

export default isEmailAddressValid;
